import { useTranslation } from "@/hooks/useTranslation"
import { useIntegration } from "@/pages/IntegrationsPage/hooks/useIntegration"

import type { BitbucketInstallation } from "@/api/useIntegrations.types"
import type { BitbucketConfigurationTabProps } from "."
import { BitbucketConfigurationItem } from "./BitbucketConfigurationItem"

export const BitbucketConfigurationTab = (
  props: BitbucketConfigurationTabProps
) => {
  const keyPrefix = "integrations.configuration.Bitbucket."
  const { t } = useTranslation()
  const [data] = useIntegration(props)
  const installations =
    (data?.configuration?.installations as BitbucketInstallation[]) || []
  const noData = !installations.length

  return (
    <>
      {noData && t(`${keyPrefix}noInstallations`)}
      {!noData &&
        installations.map((item) => {
          const name = item.workspaceSlug || item.clientKey

          return (
            <BitbucketConfigurationItem
              key={item.id}
              keyPrefix={keyPrefix}
              values={{ name, ...item }}
              {...props}
            />
          )
        })}
    </>
  )
}
